import { observer } from "mobx-react";

const Action = observer((props) => {

    return (
      {/*
      <div className="card-action-element">
        <div className="dropdown">
          <button
            type="button"
            className="btn dropdown-toggle hide-arrow p-0"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="ti ti-dots-vertical text-muted"></i>
          </button>
          <ul className="dropdown-menu dropdown-menu-end">
            <li>
              <a className="dropdown-item" href="javascript:void(0);">
                Share timeline
              </a>
            </li>
            <li>
              <a className="dropdown-item" href="javascript:void(0);">
                Suggest edits
              </a>
            </li>
            <li>
              <hr className="dropdown-divider" />
            </li>
            <li>
              <a className="dropdown-item" href="javascript:void(0);">
                Report bug
              </a>
            </li>
          </ul>
        </div>
      </div>
       */}
    );
  });
  
  export default Action;
